import { Locale } from '../../shared/types';
import useStateContext from '../useStateContext';

const useLocale: () => Locale = () => {
  const { locale } = useStateContext();
  return locale.value;
};

export default useLocale;
